export const DELETE_OLD_DATA_START = 'DELETE_OLD_DATA_START';
export const DELETE_OLD_DATA_SUCCESS = 'DELETE_OLD_DATA_SUCCESS';
export const DELETE_OLD_DATA_FAIL = 'DELETE_OLD_DATA_FAIL';

export const UPDATE_DELETE_STATUS = 'UPDATE_DELETE_STATUS';